<template>
    <v-app id="inspire">
            <h1 class="text-capitalize p-0">{{pageTitle}}</h1>
    <v-data-table
            :headers="headers"
            :page="page"
            :pageCount="numberOfPages"
            :items="models"
            :server-items-length="totalModels"
            :options.sync="options"
            :items-per-page="rowsPerPage"
            :loading="loading"
            :footer-props="{
                itemsPerPageOptions:[5,10, 15, 20, 30, 40, 50],
            }"
            class="elevation-1"
    >
        <template v-slot:item.action="{ item }">
            <div v-html="item.action"></div>
        </template>

    </v-data-table>
    </v-app>
</template>
<script>
    import axios from 'axios';

    export default {
        name:"formulario",
        props:{
            routeName: {
                type: String,
//                default () {
//                    return {
//                        hasLabels: true,
//                        isHorizonal: false
//                    }
//                }
            },
            pageTitle: {
                type: String,
            },
            columnArray: {
                type: Array,
            },
            columnHeaders: {
                type: Array,
            },
        },
        data: () => ({
//            props: ['rowsPerPage'],
            draw: 1,
            page:0,
            totalModels:0,
            numberOfPages:0,
            models: [],
            loading: true,
            options: {},
            rowsPerPage: 5,
            columns:{},
            cancelSource: null,
            headers:[
                { text: 'Actions', value: 'actions', sortable: false, searchable: false, width: '210px'},
                { text: 'ID', value: 'user_id', name: 'user_id', sortable: false, searchable: false, width: '40px'},
                { text: 'Name', value: 'user_name', name: 'user_name', sortable: false, searchable: false, width: '250px'},
                { text: 'Email', value: 'user_email', name:'user_email', sortable: false, searchable: false, width: '80px'},
            ],
        }),
        watch: {
            options: {
                handler () {
                    this.getDataFromApi()
                        .then(data => {
                            this.models = data.items;
                            this.totalModels = data.total;
                        })
                },
            },
            deep: true,
        },
//        created: function () {
//            // _.debounce is a function provided by lodash to limit how
//            // often a particularly expensive operation can be run.
//            // In this case, we want to limit how often we access
//            // yesno.wtf/api, waiting until the user has completely
//            // finished typing before making the ajax request. To learn
//            // more about the _.debounce function (and its cousin
//            // _.throttle), visit: https://lodash.com/docs#debounce
//            this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500)
//        },
        mounted() {

            this.headers = this.columnHeaders;
            this.columns = this.columnArray;
        },
        methods: {
            deleteItem(item) {
                const index = this.posts.indexOf((x) => x.id === item.id);
                this.posts.splice(index, 1);
            },
            cancelRequest() {

                //Axios cancelSource to stop current search if new value is entered
                if (this.cancelSource) {
                    this.cancelSource.cancel('Start new search, stop active search');
                }
            },

            getDataFromApi() {

                //show loading of Vuetify Table
                this.loading = true;

                return new Promise((resolve, reject) => {

                    this.cancelRequest();

                    this.cancelSource = axios.CancelToken.source();

                    //copy current params to modify
                    let options = this.options;

                    options.length = this.rowsPerPage; //set how many records to fecth per page
                    options.start = options.page == 1 ? 0 : (this.rowsPerPage * (options.page - 1)); //set offset
                    options.search = {
                        value: options.query,
                        regex: false
                    }; //our search query

                    options.draw = this.draw;

                    //sorting and default to column 1 (ID)
                    console.log(options.sortBy);
                    if(options.sortBy){

//                        options.order = {
//                            0: {
//                                column: _.findIndex(this.headers, {
//                                    'value': options.sortBy
//                                }),
//                                dir: (options.descending ? 'desc' : 'asc')
//                            }
//                        };
                        options.order = {
                            0: {
                                column: 1,
                                dir: 'desc'
                            }
                        };
                        console.log(options.order);
                    }else{
                        options.order = {
                            0: {
                                column: 2,
                                dir: 'asc'
                            }
                        };
                    }
//
//                    options.order = 1;
//                    options.dir = 'desc';

                    options.columns = this.columns; //set our previously created columns

                    //fecth data
                    //I used here jQuery $.param() helper, becuase axios submits data as JSON Payload, and we need for data or Query params
                    //This can be changed
                    axios.get('/datatable/vuedatatable?routeName='+this.routeName+'&'+$.param(options), {
                        cancelToken: this.cancelSource.token
                    }).then((res) => {

                        this.loading = false;
                        this.draw++;

                        this.cancelSource = null;

                        let items = res.data.data;
                        let total = res.data.recordsFiltered;

                        resolve({
                            items,
                            total
                        });

                    }).catch((err) => {
                        if (axios.isCancel(err)) {
                            console.log('Request canceled', err.message);
                        } else {
                            reject(err);
                        }
                    });

//                .always(() => {
//                        this.loading = false;
//                    })
                });
            }
        },
        //computed params to return pagination and search criteria
//        computed: {
//            params(nv) {
//
//                return {
//                    //...this.options,
//                    //query: this.searchQuery
//                };
//            }
//        },
    };
</script>
